<template>
  <section>
    <div class="form-content" v-if="dept.length>0">
      <div class="clear">
        <el-col :span="12">
          <el-form-item label="所诉部门">
            <el-input size="small" :disabled="true" v-model="dept[0].name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="采购人">
            <el-input size="small" :disabled="true" v-model="userData.name"></el-input>
          </el-form-item>
        </el-col>
      </div>

      <div class="clear">
        <el-col :span="12">
          <el-form-item label="申请时间">
            <el-date-picker v-model="form.applyTime" style="width:250px!important;" value-format="yyyy-MM-dd HH:mm:ss"
              size="small" type="datetime" placeholder="选择申购时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </div>

      <el-form-item label="物品明细">
        <section class="consumable-list">
          <div class="list-title">
            <div class="r">
              <el-button @click="AddConsumable()" type="primary" size="mini">添加物品</el-button>
            </div>
          </div>
          <div class="consumable-table">
            <el-table :data="form.items" border>
              <el-table-column prop="name" label="物品名称">
              </el-table-column>
              <el-table-column prop="consumable.spec" label="规格型号">
              </el-table-column>
              <el-table-column prop="consumable.unit.name" label="单位" width="50" align="center">
              </el-table-column>
              <el-table-column prop="amount" width="80" align="center" label="数量">
              </el-table-column>
              <el-table-column prop="price" align="center" label="单价">
              </el-table-column>
              <el-table-column prop="totalPrice" align="center" label="总价">
              </el-table-column>
              <!-- <el-table-column prop="totalPrice" align="center" label="备注">
              </el-table-column> -->

              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="点击变更信息" placement="bottom">
                    <i @click="ConsumableChange(scope.row, scope.$index)"
                      class="iconfont icon-xiugai meeting-btn-icon  mbi-edit"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="点击删除" placement="bottom">
                    <i @click="ConsumableDelete(scope.$index)"
                      class="iconfont icon-close meeting-btn-icon mbi-remove"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </section>
      </el-form-item>
    </div>
    <!-- 添加材料 -->
    <div class="pop-room" v-if="addStatus">
      <a href="javascript:;" @click="addStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="mform" label-width="120px" class="form">
            <el-form-item label="*物品名称">
              <el-select @change="forceUpdate" size="small" style="width:100%" filterable v-model="mform.consumableId" placeholder="支持搜索">
                <!-- <el-option v-for="item in consumableList" :key="item.id" :label="item.name" :value="item.id">
                </el-option> -->

                <el-option v-for="item in consumableList" :key="item.id"
                  :label="item.name+' ('+item.dl.name+')'+(item.spec?' 【'+item.spec+'】':'')" :value="item.id">
                </el-option>

              </el-select>
            </el-form-item>
            <el-form-item v-if="mform.consumable" label="规格型号">
              <el-input size="small" :disabled="true" v-model="mform.consumable.spec"></el-input>
            </el-form-item>
            <el-form-item v-if="mform.consumable" label="单位">
              <el-input size="small" :disabled="true" v-model="mform.consumable.unit.name"></el-input>
            </el-form-item>

            <el-form-item label="*数量">
              <el-input size="small" type="number" v-model="mform.amount"></el-input>
            </el-form-item>
            <el-form-item label="*单价">
              <el-input size="small" type="number" v-model="mform.price"></el-input>
            </el-form-item>
            <el-form-item label="总价">
              <el-input size="small" :disabled="true" type="number" v-model="mform.totalPrice"></el-input>
            </el-form-item>

            <el-form-item label="">
              <el-button @click="AddBtnClick()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>
  </section>

</template>
<script>
  export default {
    props: ['formByFather', 'userData', 'isBack'],
    data() {
      return {
        form: {},

        // supplierList: '',
        // unitList: '',
        consumableList: '',

        addType: 0,
        editIndex: '',
        mform: {
          consumable: '',
          consumableId: '',
          amount: '',
          price: '',
          totalPrice: 0,
        },

        dept: {},
        depId: '',
        addStatus: false,

        typeArr: ['办公用品', '日常用品', '其他用品'],
      }
    },
    created() {
      // 获取部门
      this.getDept()

      this.depId = this.userData.secDepIds.split(",")[0] / 1
    },
    mounted() {
      this.form = this.formByFather

      // this.getSupplierList()
      // this.getUnitList()
      this.getConsumableList()
    },
    methods: {
      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      // 获取部门
      getDept() {
        ajax.get('/user/dept', '', (res) => {
          this.dept = res.vo.array
          this.form.depId = this.dept[0].id
        })
      },

      // 编辑材料
      ConsumableChange(row, index) {
        this.addType = 1
        this.editIndex = index
        this.mform = row
        this.addStatus = true
      },
      // 从列表里删除当前材料
      ConsumableDelete(index) {
        // console.log(index)
        this.form.items.splice(index, 1)
      },
      // 显示添加材料弹窗
      AddConsumable() {
        this.mform = {
          consumable: '',
          consumableId: '',
          amount: '',
          price: '',
          totalPrice: 0,
        }
        this.addType = 0
        this.addStatus = true
      },
      // 添加材料到列表
      AddBtnClick() {
        if (!this.mform.consumableId || !this.mform.amount) {
          this.$message.error("请认真填写材料信息，带*为必填项")
          return
        }
        // this.mform.consumable = this.consumableList.find((obj) => {
        //   return obj.id == this.mform.consumableId
        // })

        this.mform.name = this.mform.consumable.name
        if (this.addType == 0) {
          this.form.items.push(this.mform)
        } else {
          this.form.items.splice(this.editIndex, 1, this.mform)
        }

        let _total = 0
        for (var i = 0; i < this.form.items.length; i++) {
          _total += parseFloat(this.form.items[i].totalPrice)
        }
        this.form.total = _total.toFixed(2)

        // 初始化
        this.mform = {
          consumable: '',
          consumableId: '',
          amount: '',
          price: '',
          totalPrice: 0,
        }
        this.addStatus = false
      },
      // 获得计量单位名称
      getUnitName(unitId) {
        for (var i = 0; i < this.unitList.length; i++) {
          let _item = this.unitList[i]
          if (unitId == _item.id) {
            return _item.name
          }
        }
      },
      // 获取材料基础资料列表
      getConsumableList() {
        ajax.get('/consumable/list', '', (res) => {
          this.loading = false
          this.consumableList = res.vo.array
        })
      },
      // 返回form
      getFromData() {
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      },
      'mform.consumableId'() {
        console.log(this.consumableList)
        let _consumable = this.consumableList.find((obj) => {
          return obj.id == this.mform.consumableId
        })
        this.$set(this.mform, 'consumable', _consumable)
      },
      'mform.amount'() {
        console.log(2)
        if (this.mform.price && this.mform.amount) {
          this.mform.totalPrice = (this.mform.price * this.mform.amount).toFixed(2)
        }
      },
      'mform.price'() {
        if (this.mform.price && this.mform.amount) {
          this.mform.totalPrice = (this.mform.price * this.mform.amount).toFixed(2)
        }
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/consumable/planApply.vue